function SearchArea(props: any) {
  let myProps = {
    list: (inOptObj: any) => { },
    listOpt: {},
    setListOpt: (inOptObj: any) => { },
    isShowRight: true,
    setIsShowRight: (inIsShowRight: boolean) => { },
    goWriteFrame: (inIsUpdate: boolean) => { },
    goDelete: (inData: any) => { },
    ...props
  };
  let listOpt = myProps.listOpt;
  let isShowRight = myProps.isShowRight;

  const on_change_search_input = (e: any) => {
    let target = e.target;
    let name = e.target.name;
    let value = e.target.value;

    let search_list_opt = {
      ...listOpt,
      [name]: value,
      now_page: "1"
    };
    if (target.tagName.toLowerCase() === "select"
      || target.type === "checkbox" || target.type === "radio") {
      myProps.list(search_list_opt);
    } else {
      myProps.setListOpt(search_list_opt);
    }
  };

  const onKeyUpEnterSearch = (e: any) => {
    if (e.key === 'Enter') { myProps.list({ now_page: 1 }); }
  };

  return (
    <div className="btn-box-left relative h-8" style={{ lineHeight: "22px" }}>
      <input type="text" className="search-input" name="s_name_like" value={listOpt.s_name_like}
        onChange={on_change_search_input} style={{ width: "80px", lineHeight: "22px" }}
        autoComplete="off" placeholder="이름"
        onKeyUp={onKeyUpEnterSearch} />
      사용여부:
      <select className="search-input_select"
        value={listOpt.s_is_use}
        onChange={(e: any) => { myProps.list({ "now_page": "1", "s_is_use": e.target.value }) }} >
        <option value="" >전체</option>
        <option value="1" >사용</option>
        <option value="empty" >미사용</option>
      </select>
      <button className="btn btn-dark ml-2" onClick={() => { myProps.goWriteFrame(false); }}>신규등록</button>
      <button className="btn btn-dark" onClick={myProps.goDelete}>삭제</button>
      <button className="btn btn-dark"
        onClick={() => { myProps.setIsShowRight(!isShowRight); }}
      >
        {isShowRight ? "-" : "+"}
      </button>
    </div>
  );
};
export default SearchArea;